import { Deserializable } from '../protocols/deserializable';

export class VbWithdrawalAmount implements Deserializable {
  public accountBalance!: number;
  public startingMonth!: number;
  public remainingMonths!: number;
  public memberAge!: number;
  public spousalAge!: number;
  public minAnnualWithdrawalAmount!: number;
  public maxAnnualWithdrawalAmount!: number;
  public planYear!: number;
  public memberAgeOnDecember31!: number;
  public memberMustWithdraw!: boolean;
  public ageForMinWithdrawalFactor!: number;
  public minWithdrawalFactor!: number;
  public minWithdrawalFactorYear!: number;
  public ageForMaxWithdrawalFactor!: number;
  public maxWithdrawalFactor!: number;
  public maxWithdrawalFactorYear!: number;

  onDeserialize() {}
}
